export default {
  path: '/appointment',
  component: () => import('@/views/appointment/appointment-router.vue'),
  children: [
    {
      path: '',
      name: 'Appointment',
      component: () => import('@/views/appointment/pages/AppointmentPatient/AppointmentPatient.vue'),
      meta: {
        name: 'navigationDrawer.appointment',
        icon: '/icons/calendar-app.svg',
        auth: true
      }
    },
    {
      path: 'examination',
      name: 'AppointmentExamination',
      component: () => import('@/views/appointment/pages/AppointmentExamination/AppointmentExamination.vue'),
      meta: {
        name: 'navigationDrawer.appointment',
        icon: '/icons/calendar-app.svg',
        auth: true
      }
    },
    {
      path: 'doctors',
      name: 'AppointmentDoctors',
      component: () => import('@/views/appointment/pages/AppointmentDoctors/AppointmentDoctors.vue'),
      meta: {
        name: 'navigationDrawer.appointment',
        icon: '/icons/calendar-app.svg',
        auth: true
      }
    },
    {
      path: '/appointment-print/:id',
      name: 'AppointmentPrint',
      component: () => import('@/views/appointment/pages/AppointmentPatient/AppointmentPrint.vue'),
      meta: {
        name: 'navigationDrawer.appointment',
        icon: '/icons/calendar-app.svg',
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: '/appointment-print-all/',
      name: 'AppointmentPrintAll',
      component: () => import('@/views/appointment/pages/AppointmentPatient/AppointmentPrintAll.vue'),
      meta: {
        name: 'navigationDrawer.appointment',
        icon: '/icons/calendar-app.svg',
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: '/print-examination/',
      name: 'PrintExamination',
      component: () => import('@/views/appointment/pages/AppointmentExamination/PrintExamination.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    }

  ]
}
